import z from "zod";

import { createPostPurchaseRecommendationsDataModel } from "@/domains/surveys/factories/create-post-purchase-recommendations-data-model";
import { createPostPurchaseSurveyParamsDataModel } from "@/domains/surveys/factories/create-post-purchase-survey-params-data-model";
import {
  POST_PURCHASE_EFFECTIVENESS,
  POST_PURCHASE_NEXT_STEPS_TYPES,
  POST_SURVEY_DESTINATION,
  SURVEY_ENTRY_SOURCES,
} from "@/domains/surveys/models/constants";

export const postPurchaseEffectivenessSchema = z.enum(POST_PURCHASE_EFFECTIVENESS);

export const postPurchaseSurveySearchSchema = z.object({
  order_id: z.int(),
  effectiveness: postPurchaseEffectivenessSchema,
});

export const postPurchaseSubscribeSearchSchema = z.object({
  order_id: z.int(),
});

export const postPurchaseSurveyParamsSchema = z.array(z.tuple([z.string(), z.string()]));

export const postPurchaseRecommendationsSearchSchema = z.object({
  order_id: z.int(),
  flow_uuid: z.string(),
});

const postPurchaseNextStepSchema = z.object({
  header: z.string(),
  description: z.string(),
  type: z.enum(POST_PURCHASE_NEXT_STEPS_TYPES),
});

const postPurchaseUpsellProductSchema = z.object({
  name: z.string(),
  description: z.string(),
  imgUrl: z.string(),
  url: z.string(),
  price: z.number(),
  variantId: z.string(),
});

const postPurchaseBuyerSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.email(),
});

export const postPurchaseRecommendationsResponseSchema = z.object({
  buyer: postPurchaseBuyerSchema,
  steps: z.array(postPurchaseNextStepSchema),
  products: z.array(postPurchaseUpsellProductSchema),
});

export const postPurchaseRecommendationsDataModelSchema =
  postPurchaseRecommendationsResponseSchema.transform(createPostPurchaseRecommendationsDataModel);

export const surveyParamsResponseSchema = z.array(z.tuple([z.string(), z.string()]));

export const surveyEntrySourceSchema = z
  .enum(SURVEY_ENTRY_SOURCES)
  .catch(SURVEY_ENTRY_SOURCES.ORGANIC);

export const surveySearchSchema = z.object({
  entry_source: surveyEntrySourceSchema,
});

export const postPurchaseSurveyParamsDataModelSchema = surveyParamsResponseSchema.transform(
  createPostPurchaseSurveyParamsDataModel,
);

/** Strict on purpose: a `.catch()` would make the fallback and a real answer indistinguishable. */
export const postSurveyDestinationSchema = z.enum(POST_SURVEY_DESTINATION);

export const checkSurveyCompletionResponseSchema = z
  .object({
    /** `.nullish()`: a backend that predates the field is expected, a value we do not know is not. */
    destination: postSurveyDestinationSchema.nullish(),
  })
  .nullable();
